__turbopack_context__.v({
  "back-button": "Confirmation-module-scss-module__MQoqKG__back-button",
  "check-icon": "Confirmation-module-scss-module__MQoqKG__check-icon",
  "container": "Confirmation-module-scss-module__MQoqKG__container",
  "placeholder": "Confirmation-module-scss-module__MQoqKG__placeholder",
});
